import { Fragment } from "react";
import { Card } from "react-bootstrap";

export default function TransferenciasLayout({ children }) {
    return (
        <Fragment>
            <Card className='card-user'>
                {children}
            </Card>
        </Fragment>
    )
}
